import React from "react";
import { useTranslation } from "react-i18next";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import mapa from "../../img/mapa.jpg";
import strelki from "../../img/strelki.png";
import tabela from "../../img/table.png";

const Blog2 = () => {
  const { t } = useTranslation();
  return (
    <>
      <Header></Header>
      <div className="container mx-auto mt-10">
        <h1 className="font-bold text-center text-2xl mb-10">
          {t("blog2_title1")}
        </h1>
        <div>{t("blog2_section1")}</div>
        <br />
        <div>{t("blog2_section2")}</div>
        <div className="flex flex-row place-content-center mx-auto block text-center">
          <img src={mapa} className="w-100 mt-5" />
        </div>
        <br />
        <div>{t("blog2_section3")}</div>
        <br />
        <h1 className="font-bold text-xl">{t("blog2_title2")}</h1>
        <br />
        <div>{t("blog2_section4")}</div>
        <br />
        <h1 className="font-bold text-xl">{t("blog2_title3")}</h1>
        <br />
        <div className="flex flex-row place-content-center mx-auto block text-center mt-5 mb-5">
          <img src={strelki} className="w-100" />
        </div>
        <h1 className="font-bold text-xl">{t("blog2_title4")}</h1>
        <br />
        <div>{t("blog2_section5")}</div>
        <br />
        <div>{t("blog2_section6")}</div>
        <br />
        <div>{t("blog2_section7")}</div>
        <br />
        <div>{t("blog2_section8")}</div>
        <br />
        <div className="flex flex-row place-content-center mx-auto block text-center mt-5 mb-5">
          <img src={tabela} className="w-100" />
        </div>
        <div>{t("blog2_section9")}</div>
        <br />
        <h1 className="font-bold text-xl">{t("blog2_title5")}</h1>
        <br />
        <div>{t("blog2_section10")}</div>
        <br />
        <div className="mb-10">{t("blog2_section11")}</div>
        <h1 className="font-bold text-lg">{t("blog2_title6")}</h1>
        <br />
        <div className="mb-20">
          {t("blog2_section12")}
          <a href="www.izbornaarhiva.mk">www.izbornaarhiva.mk</a>
          <br />
          {t("blog2_section13")}
          <a href="https://sobranie.mk/">https://sobranie.mk/</a> <br />
          {t("blog2_section14")}
          <a href="https://vlada.mk/">https://vlada.mk/</a>
        </div>
      </div>
      <Footer />
    </>
  );
};
export default Blog2;
